import { getVimeoIFrame } from "../components/vimeo";

function activateQuiz () {

    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    scrollToTop();

    const activateSlider = (sliderId) => {
        const slideToActivate = document.querySelector(`.quiz-slide[data-slide="${sliderId}"]`);
        if (!slideToActivate) return false;

        const allSliders = document.querySelectorAll('.quiz-slide');
        for (const slider of allSliders) {
            slider.classList.remove('active', 'animated');
        }

        slideToActivate.classList.add('active', 'animated');
        scrollToTop();
        return true;
    }

    let history = [document.querySelector('.quiz-slide.active').dataset.slide];

    const goNext = (sliderId) => {
        if (activateSlider(sliderId)) {
            history.push(sliderId);
            scrollToTop();
        }
    }

    const goPrevious = () => {
        if (history.length > 1 && activateSlider(history[history.length - 2])) {
            history.pop();
        }
    }

    const registerSlideButtonEvents = () => {
        const quizButtons = document.querySelectorAll('.quiz-slide-button');
        for (const quizButton of quizButtons) {
            quizButton.addEventListener('click', (e) => {
                e.preventDefault();
                goNext(quizButton.dataset.target);
            });
        }
    }

    const registerRadioButtonEvents = () => {
        const quizRadios = document.querySelectorAll('.quiz-slide-radio');
        for (const quizRadio of quizRadios) {
            quizRadio.addEventListener('change', (e) => {
                e.preventDefault();
                goNext(quizRadio.value);
                quizRadio.checked = false;
            });
        }
    }

    const registerRefreshSlideButtonsEvent = () => {
        const refreshButtons = document.querySelectorAll('.quiz-refresh');
        for (const refreshButton of refreshButtons) {
            refreshButton.addEventListener('click', (e) => {
                e.preventDefault();
                activateSlider(history[0]);
                history = [history[0]];
            });
        }
    }

    const registerVimeoPlayButtonEvent = () => {
        const modal = document.querySelector('#videoModal');
        const modalBody = modal.querySelector('.modal-body');

        const vimeoButtons = document.querySelectorAll('.video-play-link');
        for (const vimeoButton of vimeoButtons) {
            vimeoButton.addEventListener('click', (e) => {
                e.preventDefault();

                const $modal = jQuery(modal);
                $modal.modal('show');

                const vimeoId = vimeoButton.dataset.vimeo;
                modalBody.innerHTML = getVimeoIFrame(vimeoId);
            });
        }

        modal.addEventListener('hidden.bs.modal', function () {
            modalBody.innerHTML = '';
        });
    }

    window.quizGoPrevious = goPrevious;
    registerSlideButtonEvents();
    registerRadioButtonEvents();
    registerRefreshSlideButtonsEvent();
    registerVimeoPlayButtonEvent();
}

if (document.querySelector('.quiz-slide')) {
    activateQuiz();
}
